import { theme } from '@/features/shared/constants/shiptTheme'
import styled from 'styled-components'
import { keyframes } from '@/features/shared/styles/effects'

export const OrderStatusIndicator = styled.div`
  --ping-color: ${theme.color.content.base.neutral.primary};

  margin-right: 1rem;
  margin-left: 0.375rem;
  height: 12px;
  width: 12px;
  background-color: var(--ping-color);
  border-radius: 100%;
  box-sizing: content-box;
  flex-shrink: 0;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 50%;
    animation: ${keyframes.ping} 1500ms ease-out infinite;
    will-change: box-shadow;
  }

  &[data-variant='inverse'] {
    --ping-color: ${theme.color.background.base.neutral.subtle_00};
  }
`
